import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

export const uploadFileToStorage = async (file, folder, customFileName = null) => {
  if (!file) return null; // If no file is selected, skip

  try {
    const storage = getStorage();

    // Generate a unique file name if not provided
    const fileName = customFileName || file.name || `${uuidv4()}.jpg`;
    const fileRef = ref(storage, `${folder}/${fileName}`);
    
    // Upload the file to Cloud Storage
    const fileToUpload = file instanceof Blob ? file : new Blob([file], { type: file.type || "application/octet-stream" });
    await uploadBytes(fileRef, fileToUpload);

    // Get the download URL
    const downloadURL = await getDownloadURL(fileRef);

    return downloadURL;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw new Error("File upload failed");
  }
};
